import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import RestManager from "../business/RestManager";
import GigyaManager from "../business/GigyaManager";
import Constants from "../business/Constants";

class CompletaDatiCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.alphanumReg = /^[A-Za-z0-9 ']+$/;
        this.numberReg =  /^[0-9]+$/;
        this.capReg =  /\b\d{5}\b/;
        this.centReg =  /^[0-9]{2}$/;
        this.files = [];
        this.init();
    }
    init() {
        this.loadChildComponents(this);
        this.startLoader();
        let play_token = this.getUrlParameter('pt');
        if ( play_token ){
            this.visualMonopattino();
        } else {
            this.visualZainetto();
        }
        GigyaManager.getLoggedUserCached().then((u) => {
            $('#email').val(u.profile.email);
            this.removeLoader();
        }, (err) => {
            window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
        });


    }


    submit(){
        this.startLoader();
        this.validateForm();
    }

    sendForm(){
            let inputs = $('.col-form > input');
            let form = {};
            for (let i = 0; i < inputs.length; i++) {
                let input = $(inputs[i]);
                form[input.attr('name')] = input.val();
            }

            let play_token = this.getUrlParameter('pt');
            if (play_token) {
                form['play_token'] = play_token;
                RestManager.iwPrizeRequest(form).then((resp) => {
                    this.buildModal("https://static.mulinobianco.it/pew/KIDS_2019/assets/img/visual-top-monopattino.png", "Ottimo! Riceverai il Monopattino elettrico Razor con il kit di protezione! ", "Non appena il premio sarà spedito ti invieremo una mail di conferma! ", "/promozioni/il-divertimento-e-fuori/area-personale", "Torna al concorso")
                }, (err) => {
                    let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                        <div class="feedback__modal__wrap">
                                                            <div class="feedback__modal__close" component-click="close()">
                                                                <svg>
                                                                    <use xlink:href="#svg_circle_close"></use>
                                                                </svg>
                                                            </div>
                                                            <div class="feedback__modal__content">
                                                                <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                                <p>${err.status.errors.description}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                   `;
                    $(this.element).append(tmplModalGeneric);
                    this.loadChildComponents(this);
                    this.removeLoader();
                });
            } else {
                RestManager.prizeRequest(form).then((resp) => {
                    this.buildModal("https://static.mulinobianco.it/pew/KIDS_2019/assets/img/visual-top-zainetto.png", "Ottimo! Hai richiesto il pratico Zainetto.", "Quando il premio sarà spedito ti invieremo una mail di conferma! ", "/promozioni/il-divertimento-e-fuori/area-personale", "Torna al concorso")
                }, (err) => {
                    this.removeLoader();
                    let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                        <div class="feedback__modal__wrap">
                                                            <div class="feedback__modal__close" component-click="close()">
                                                                <svg>
                                                                    <use xlink:href="#svg_circle_close"></use>
                                                                </svg>
                                                            </div>
                                                            <div class="feedback__modal__content">
                                                                <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                                <p>${err.status.errors.description}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                   `;
                    $(this.element).append(tmplModalGeneric);
                    this.loadChildComponents(this);
                    this.removeLoader();
                });
        }
    }
    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };


    removeLoader(){
        $('.tool_loader').fadeOut(500).remove();
        $('body').removeClass('noScroll');
        $('#conferma').prop("disabled", false).removeClass('disabled');
    }

    startLoader(){
        $('.mb-promo-kids-2019').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
        $('body').addClass('noScroll');
        $('#conferma').prop("disabled", true).addClass('disabled');
    }

    validateForm(){

        $('.error-feedback').remove();
        $('input, select').removeClass('error');

        var varNome = this.take_nome();
        var varCognome = this.take_cognome();
        var varTelefono =  this.take_telefono();
        var varCap = this.take_cap();
        var varIndirizzo = this.take_indirizzo();
        var varCivico = this.take_ncivico();
        var varCitta = this.take_citta();
        var varProvincia = this.take_provincia();
        var varCitofono = this.take_citofono();



        if(varNome && varCognome && varTelefono && varCap && varIndirizzo && varCivico && varCitta && varProvincia && varCitofono  ) {
            this.sendForm();
        } else {
            this.removeLoader();
            return false;
        }

    }

    take_market(){
        if( $('#market').length ){
            var market = $('#market').val();
            if (market.length < 2 & market !== undefined){
                $('#market').addClass('error');
                $('.row-form--market').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo deve essere selezionato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_product(){
        if( $('#product').length ){
            var product = $('#product').val();
            if (product.length < 2 & market !== undefined){
                $('#product').addClass('error');
                $('.row-form--product').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo deve essere selezionato</span>');
            } else {
                var productArr = [ '2029000290', '2029000295', '2029000296', '2029000168', '2029004479', '9991000009', '2010119001' ];
                if (productArr.indexOf(product) >= 0){
                    return true;
                } else {
                    $('#product').addClass('error');
                    $('.row-form--product').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo deve essere selezionato</span>');
                }
            }
        } else {
            return true;
        }
    }


    take_nome(){
        if( $('#nome').length ){
            var nome = $('#nome').val();
            if (nome.length < 2 & nome !== undefined) {
                $('#nome').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                var validName = this.alphanumReg.test(nome);
                if (!validName) {
                    $('#nome').addClass('error').after('<span class="error-feedback"><span' +
                        ' class="icon-error">!</span> Il campo deve essere composto solo da' +
                        ' caratteri alfanumerici</span>');
                } else {
                    return true;
                }
            }
        } else {
            return true;
        }
    }

    take_cognome(){
        if( $('#cognome').length ){
            var cognome = $('#cognome').val();
            if (cognome.length < 2 & cognome !== undefined) {
                $('#cognome').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                var validCognome = this.alphanumReg.test(cognome);
                if (!validCognome) {
                    $('#cognome').addClass('error').after('<span class="error-feedback"><span' +
                        ' class="icon-error">!</span> Il campo deve essere composto solo da' +
                        ' caratteri alfanumerici</span>');
                } else {
                    return true;
                }
            }
        } else {
            return true;
        }
    }

    take_telefono(){
        if( $('#telefono').length ){
            var telefono = $('#telefono').val();
            if (telefono.length > 0 && telefono !== undefined) {
                var validTel = this.numberReg.test(telefono);
                if (!validTel) {
                    $('#telefono').addClass('error').after('<span class="error-feedback"><span' +
                        ' class="icon-error">!</span> Il campo deve essere composto' +
                        ' solo da' +
                        ' caratteri numerici</span>');
                }else{
                    return true;
                }
            }else{
                return true;
            }
        } else {
            return true;
        }
    }

    take_cap(){
        if( $('#cap').length ){
            var cap = $('#cap').val();
            if (cap.length < 2 & cap !== undefined) {
                $('#cap').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                var validCap = this.capReg.test(cap);
                if (!validCap) {
                    $('#cap').addClass('error').after('<span class="error-feedback"><span' +
                        ' class="icon-error">!</span> Il campo deve essere composto' +
                        ' da ' +
                        '5 caratteri numerici</span>');
                } else {
                    return true;
                }
            }
        } else {
            return true;
        }
    }

    take_ncivico(){
        if( $('#ncivico').length ){
            var ncivico = $('#ncivico').val();
            if (ncivico.length < 1 & ncivico !== undefined) {
                $('#ncivico').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_indirizzo(){
        if( $('#indirizzo').length ){
            var indirizzo = $('#indirizzo').val();
            if (indirizzo.length < 2 & indirizzo !== undefined) {
                $('#indirizzo').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_citta(){
        if( $('#citta').length ){
            var citta = $('#citta').val();
            if (citta.length < 2 & citta !== undefined) {
                $('#citta').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_citofono(){
        if( $('#citofono').length ){
            var citofono = $('#citofono').val();
            if (citofono.length < 2 & citofono !== undefined) {
                $('#citofono').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_provincia(){
        if( $('#provincia').length ){
            var provincia = $('#provincia').val();
            if (provincia.length < 2 & provincia !== undefined) {
                $('#provincia').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }
    visualMonopattino(){
        $('.visual-background').html('<div class="visual-body" style="background-image:' +
            ' url(\'https://static.mulinobianco.it/pew/KIDS_2019/assets/img/visual-top-monopattino.png\')"></div>' +
            '<div class="text-right"><h1>Il Monopattino<br/>elettetrico Razor<br/>è tuo!</h1></div>');
        $('.contenuto-premio').html('Inserisci i dati <strong>per ricevere direttamente a casa il Monopattino' +
            ' elettetrico Razor e il kit di protezione.</strong>');
    }
    visualZainetto(){
        $('.visual-background').html('<div class="visual-body" style="background-image:' +
            ' url(\'https://static.mulinobianco.it/pew/KIDS_2019/assets/img/visual-top-zainetto.png\')"></div>' +
            '<div class="text-right"><h1>Lo Zainetto<br/>è tuo!</h1></div>');
        $('.contenuto-premio').html('Inserisci i dati <strong>per ricevere direttamente a casa il pratico Zainetto.</strong>');
    }

    buildModal(img, title, text, link, linkCta){
        let modalTmpl = `
            <div class="feedback__modal" component="FeedbackModalComponent">
                <div class="feedback__modal__wrap">
                    <div class="feedback__modal__close" component-click="close()" style="display: none;">
                        <svg>
                        <use xlink:href="#svg_circle_close"></use>
                        </svg>
                    </div>
                    <div class="feedback__modal__content">
                        <img src="${img}">
                        <h2>${title}</h2>
                        <p>${text}</p>
                        <a class="button more-padding" href="${link}">${linkCta}</a>
                    </div>
                 </div>
            </div>`
        $('.mb-promo-kids-2019').append(modalTmpl);
        this.loadChildComponents(this);

    }

}

export default CompletaDatiCtrl;
